import "./App.css";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Layout from "./components/appLayout/layout";
import { HomePage } from "./pages/homePage";
import { AproposPage } from "./pages/aproposPage";
import { BlogPage } from "./pages/blogPage";
import { DetailsBlog } from "./pages/detailsBlog";
import { ContactPage } from "./pages/contactPage";
import { ServicesPage } from "./pages/servicePage";
import { ITEPage } from "./pages/ITEPage";
import { ItIPage } from "./pages/ITIPage";
import { ToiturePage } from "./pages/toiturePage";
import { FacadePage } from "./pages/façadePage";
import { InvestisseursPage } from "./pages/investisseursPage";
import { AccompagnementPage } from "./pages/accompagnementPage";
import LoginPage from "./pages/adminPages/loginPage";
import VerifCode from "./pages/adminPages/verifCodePage";
import AppLayoutAdmin from "./pages/adminPages/appLayoutAdmin";
import Dashbord from "./pages/adminPages/dashbordAdmin";
import ProtectedRoute from "./pages/adminPages/protectedRoute";
import UserListePages from "./pages/adminPages/userListe";
import NewslettreListe from "./pages/adminPages/NewsLetter";
import UserForm from "./pages/adminPages/addUtilisateur";
import UserEditForm from "./pages/adminPages/editUserPage";
import BlogForm from "./pages/adminPages/addBlog";
import ContactListe from "./pages/adminPages/contactList";
import BlogListePages from "./pages/adminPages/BlogListe";
import { UserProvider } from "./contexts/userContext";
import DevisListe from "./pages/adminPages/devisPages";
function App() {
  return (
    <>
      <UserProvider>
        {/* Ton contenu */}
        <ToastContainer position="top-right" />
        <Router>
          <Routes>
            <Route
              path="/"
              element={
                <Layout>
                  <HomePage />
                </Layout>
              }
            />
            <Route
              path="/apropos"
              element={
                <Layout>
                  <AproposPage />
                </Layout>
              }
            />
            <Route
              path="/blogs"
              element={
                <Layout>
                  <BlogPage />
                </Layout>
              }
            />
            <Route
              path="/blog/:id"
              element={
                <Layout>
                  <DetailsBlog />
                </Layout>
              }
            />
            <Route
              path="/contact"
              element={
                <Layout>
                  <ContactPage />
                </Layout>
              }
            />
            <Route
              path="/services"
              element={
                <Layout>
                  <ServicesPage />
                </Layout>
              }
            />
            <Route
              path="/ITE"
              element={
                <Layout>
                  <ITEPage />
                </Layout>
              }
            />
            <Route
              path="/ITI"
              element={
                <Layout>
                  <ItIPage />
                </Layout>
              }
            />
            <Route
              path="/toiture"
              element={
                <Layout>
                  <ToiturePage />
                </Layout>
              }
            />
            <Route
              path="/ravalement-façade"
              element={
                <Layout>
                  <FacadePage />
                </Layout>
              }
            />
            <Route
              path="/renovation-investisseurs"
              element={
                <Layout>
                  <InvestisseursPage />
                </Layout>
              }
            />
            <Route
              path="/accompagnement-administratif"
              element={
                <Layout>
                  <AccompagnementPage />
                </Layout>
              }
            />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/verif-code" element={<VerifCode />} />
            <Route
              path="/dashbord"
              element={
                <AppLayoutAdmin>
                  <Dashbord />
                </AppLayoutAdmin>
              }
            />
            <Route
              path="/user-liste"
              element={
                <ProtectedRoute>
                  <AppLayoutAdmin>
                    <UserListePages />
                  </AppLayoutAdmin>
                </ProtectedRoute>
              }
            />
            <Route
              path="/devis-liste"
              element={
                <ProtectedRoute>
                  <AppLayoutAdmin>
                    <DevisListe />
                  </AppLayoutAdmin>
                </ProtectedRoute>
              }
            />
            <Route
              path="/newsletter-liste"
              element={
                <ProtectedRoute>
                  <AppLayoutAdmin>
                    <NewslettreListe />
                  </AppLayoutAdmin>{" "}
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-user"
              element={
                <ProtectedRoute>
                  <AppLayoutAdmin>
                    <UserForm />
                  </AppLayoutAdmin>
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-user/:id"
              element={
                <ProtectedRoute>
                  <AppLayoutAdmin>
                    <UserEditForm />
                  </AppLayoutAdmin>
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-blog"
              element={
                <ProtectedRoute>
                  <AppLayoutAdmin>
                    <BlogForm />
                  </AppLayoutAdmin>
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-blog/:id"
              element={
                <ProtectedRoute>
                  <AppLayoutAdmin>
                    <BlogForm />
                  </AppLayoutAdmin>
                </ProtectedRoute>
              }
            />
            <Route
              path="/contact-liste"
              element={
                <ProtectedRoute>
                  <AppLayoutAdmin>
                    <ContactListe />
                  </AppLayoutAdmin>
                </ProtectedRoute>
              }
            />{" "}
            <Route
              path="/blog-liste"
              element={
                <ProtectedRoute>
                  <AppLayoutAdmin>
                    <BlogListePages />
                  </AppLayoutAdmin>
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </UserProvider>
    </>
  );
}

export default App;
